import React from 'react';
import classNames from 'classnames';
import { Form, Input, Select, Modal as NewModal } from 'antd';
import { Modal } from 'antd-mobile';
import { Clickable } from '@/components';
import claimSuccessPng from '@/assets/images/claimFreebies/Icon-feather-check@3x.png';

// antd-mobile v5 弹窗默认 min-width 280px / max-width 75vw,与升级前 v2 的满宽卡片(左右各留 0.24rem)不一致,
// 通过 CenterPopup 的 CSS 变量复刻 v2 宽度;遮罩同步为 v2 的 40% 黑度
const MODAL_VIEWPORT_STYLE = {
  '--min-width': 'calc(100vw - 0.48rem)',
  '--max-width': 'calc(100vw - 0.48rem)',
};
const MODAL_MASK_STYLE = { backgroundColor: 'rgba(0, 0, 0, 0.4)' };

export const ClaimSuccessModal = ({
  visible,
  styles,
  pageFontFamily,
  pageRenderDetail,
  mainColor,
  closeStyle,
  onJump,
  onClose,
}) => {
  if (!visible) return null;

  // antd-mobile v5 的 Modal 不渲染 children,内容必须通过 content 传入
  const content = (
    <div className={styles.claimSuccessModal}>
      <img src={claimSuccessPng} alt="" />
      <div className={styles.title}>{pageRenderDetail?.claimRewardPopupTitleText}</div>
      <div className={styles.tip}>{pageRenderDetail?.claimRewardPopupBodyText}</div>
      <div className={styles.btnArr}>
        <Clickable
          className={styles.prymentBtn}
          style={{ backgroundColor: mainColor }}
          onClick={onJump}
        >
          {pageRenderDetail?.claimRewardPopupButtonText}
        </Clickable>
        {pageRenderDetail?.closeButtonTextSwitch === 'Y' && (
          <Clickable className={styles.closeBtn} onClick={onClose} style={closeStyle}>
            {pageRenderDetail?.closeButtonText}
          </Clickable>
        )}
      </div>
    </div>
  );

  return (
    <Modal
      visible
      draggable={false}
      bodyStyle={{ fontFamily: pageFontFamily }}
      bodyClassName={styles.modalStyles}
      style={MODAL_VIEWPORT_STYLE}
      maskStyle={MODAL_MASK_STYLE}
      content={content}
    />
  );
};

export const ServiceNumberModal = ({
  visible,
  styles,
  form,
  pageFontFamily,
  pageRenderDetail,
  chooseSubNumMethod,
  serviceNumberList,
  phoneRegex,
  mainColor,
  GCPI18n,
  onClose,
  onClaim,
}) => {
  if (!visible) return null;

  const requiredRule = {
    required: true,
    message: GCPI18n('lb_point_field_required'),
  };
  const phoneRule = () => ({
    validator(_, value) {
      let reject = null;
      try {
        if (value && !new RegExp(phoneRegex).test(value)) {
          reject = Promise.reject(new Error(GCPI18n('lb_point_field_invalid')));
        } else {
          reject = Promise.resolve();
        }
      } catch (error) {
        reject = Promise.resolve();
      }
      return reject;
    },
  });

  return (
    <NewModal
      open
      draggable={false}
      styles={{ fontFamily: pageFontFamily }}
      wrapClassName={classNames(styles.modalStyles, styles.claimModalWrap)}
      closable={false}
      footer={null}
    >
      <div className={styles.serviceNumberWrap}>
        <div className={styles.title}>{pageRenderDetail?.chooseSubscriberNumberTitle}</div>
        <div className={styles.body}>{pageRenderDetail?.chooseSubscriberNumberBody}</div>
        <Form name="serviceNumber" form={form} autoComplete="off" requiredMark={false}>
          <div className={styles.container}>
            {chooseSubNumMethod === '66' && (
              <Form.Item name="serviceNumber" rules={[requiredRule, phoneRule]}>
                <Input placeholder={GCPI18n('lb_enter_service_number')} />
              </Form.Item>
            )}
            {chooseSubNumMethod === '67' && (
              <Form.Item name="serviceNumber" rules={[requiredRule]}>
                <Select
                  placeholder={GCPI18n('lb_select_service_number')}
                  getPopupContainer={() => document.querySelector(`.${styles.claimModalWrap}`)}
                  options={serviceNumberList.map(item => ({
                    value: item.serviceNumber,
                    label: item.serviceNumber,
                  }))}
                />
              </Form.Item>
            )}
          </div>
        </Form>
        <div className={styles.btnList}>
          <Clickable className={classNames(styles.btnItem, styles.closeBtn)} onClick={onClose}>
            {GCPI18n('btn_close')}
          </Clickable>
          <Clickable
            className={classNames(styles.btnItem, styles.claimBtn)}
            onClick={onClaim}
            style={{ backgroundColor: mainColor }}
          >
            {GCPI18n('lb_chanllenge_claim')}
          </Clickable>
        </div>
      </div>
    </NewModal>
  );
};

export const RewardClaimDialogs = ({
  claimFlow,
  styles,
  form,
  pageFontFamily,
  pageRenderDetail,
  chooseSubNumMethod,
  serviceNumberList,
  phoneRegex,
  mainColor,
  GCPI18n,
  closeStyle,
}) => (
  <>
    <ClaimSuccessModal
      visible={claimFlow.claimSuccessVisible}
      styles={styles}
      pageFontFamily={pageFontFamily}
      pageRenderDetail={pageRenderDetail}
      mainColor={mainColor}
      closeStyle={closeStyle}
      onJump={claimFlow.handleJumpLink}
      onClose={() => claimFlow.setClaimSuccessVisible(false)}
    />
    <ServiceNumberModal
      visible={claimFlow.modelVis}
      styles={styles}
      form={form}
      pageFontFamily={pageFontFamily}
      pageRenderDetail={pageRenderDetail}
      chooseSubNumMethod={chooseSubNumMethod}
      serviceNumberList={serviceNumberList}
      phoneRegex={phoneRegex}
      mainColor={mainColor}
      GCPI18n={GCPI18n}
      onClose={claimFlow.handleCloseModal}
      onClaim={claimFlow.handleClickClaimBtn}
    />
  </>
);
